<template>
    <div id="page-areas">
        <div class="row">
            <div class="col-xl-5 col-12 p-0">
                <div class="h1 labgrotesque-bold text-xl-center text-left px-xl-0 px-4">
                    {{ $t($route.meta.title) }}
                    <hr class="hr-title-mobile">
                </div>
            </div>

            <div class="col-xl-7 col-12 p-xl-0 px-4 z-index-1000">
                <div class="labgrotesque-bold text-white-xlblack" id="areas">
                    <ul>
                        <li v-for="(area, index) in areas" :id="'li-area-' + index" class="d-inline-block d-xl-block">
                            <div class="line-areas d-none d-xl-inline-block"></div><h2 class="d-inline-block mb-0" v-html="area.title" @click="activeArea(index)"></h2>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="row d-none d-xl-flex">
            <div class="col-xl-5 p-0"></div>
            <div class="col-xl-7 p-0">
                <div class="bg-gray" id="box-areas">
                    <div class="p-2">
                        <i class="fas fa-angle-left fa-3x mr-3 cursor-pointer hvr-pulse" @click="prev()"></i>
                        <i class="fas fa-angle-right fa-3x ml-3 cursor-pointer hvr-pulse" @click="next()"></i>
                    </div>
                </div>
            </div>
        </div>

        <div id="current-area-gallery" :class="['pl-xl-0 pl-4', {'position-absolute': $root.getClassSize() === 'xl'}]" v-if="areas.length > 0">
            <div class="carousel slide h-100" data-ride="carousel" :key="keygallery">
                <div class="carousel-inner h-100">
                    <div :class="['carousel-item h-100', {'active': index == 0}]" v-for="(path, index) in currentarea.field_ambiti_immagini">
                        <img :class="['img-fluid', {'h-100': $root.getClassSize() == 'xl'}]" :src="path">

                        <div class="alt-image">
                            {{ currentarea.field_ambiti_immagini_1[index] }}

                            <template v-if="$root.getClassSize() !== 'xl'">
                                <i class="fas fa-angle-right fa-2x ml-2 cursor-pointer float-right hvr-pulse" @click="next()"></i>
                                <i class="fas fa-angle-left fa-2x mr-2 cursor-pointer float-right hvr-pulse" @click="prev()"></i>
                            </template>
                        </div>
                    </div>
                </div>

                <!--<template v-if="$root.getClassSize() !== 'xl'">
                    <a class="carousel-control-prev" href="#current-area-gallery .carousel" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#current-area-gallery .carousel" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </template>-->
            </div>
        </div>

        <div class="strip-red position-absolute d-none d-xl-block"></div>

        <div v-if="$root.getClassSize() !== 'xl'" class="bg-gray w-75 position-absolute" id="box-areas-mobile"></div>
    </div>
</template>

<script>
export default {
    name: "areas",

    data() {
        return {
            areas: [],
            currentarea: null,
            keygallery: 0
        }
    },

    created() {
        axios.get(this.$route.meta.api + "/" + this.$root.getLanguage(), this.$root.auth)
        .then(response => {
            var areas = response.data;
            $.each(areas, function(index, value) {
                areas[index]["field_ambiti_immagini"] = value.field_ambiti_immagini.split("|");
                areas[index]["field_ambiti_immagini_1"] = value.field_ambiti_immagini_1.split("|");
            });

            this.currentarea = areas[0];
            this.areas = areas;

            this.$nextTick(function() {
                this.viewAreas();
                this.setEventCarousel();

                $("#li-area-0").addClass("area-active");
            });
        });
    },

    methods: {
        next() {
            $('#current-area-gallery .carousel').carousel('next');
        },

        prev() {
            $('#current-area-gallery .carousel').carousel('prev');
        },

        activeArea(index) {
            if(!$("#li-area-" + index).hasClass("area-active")) {
                var thisObj = this;
                $("li.area-active").removeClass("area-active");
                $("#li-area-" + index).addClass("area-active");

                this.$root.animejs.timeline({loop: false})
                .add({
                    targets: '#current-area-gallery',
                    opacity: 0,
                    easing: "easeInOutQuad",
                    duration: 250,
                    complete: function(anim) {
                        thisObj.currentarea = thisObj.areas[index];
                        thisObj.keygallery += 1;
                        thisObj.setEventCarousel();
                    }
                })
                .add({
                    targets: '#current-area-gallery',
                    opacity: [0, 1],
                    easing: "easeInOutQuad",
                    duration: 250,
                    begin: function(anim) {
                        if(thisObj.$root.getClassSize() === "xl") {
                            var widthDisplay = $(window).width();
                            var positionAreas = $("#areas").offset();
                            var widthImg = widthDisplay - positionAreas.left - 70;
                            $("#current-area-gallery img").css("width", widthImg + "px");
                        }
                    }
                });
            }
        },

        viewAreas() {
            var thisObj = this;
            setTimeout(function() {
                var heightDisplay = $(window).height();
                var heightFooter = $("footer").height();
                if(thisObj.$root.getClassSize() === "xl") {
                    var widthDisplay = $(window).width();
                    var position = $("#box-areas").offset();
                    var height = heightDisplay - position.top - heightFooter;
                    $("#box-areas").height(height);

                    var positionAreas = $("#areas").offset();

                    $("#current-area-gallery").css("top", positionAreas.top + "px");
                    $("#current-area-gallery").css("left", positionAreas.left + "px");

                    var widthImg = widthDisplay - positionAreas.left - 70;
                    $("#current-area-gallery img").css("width", widthImg + "px");

                    $("#page-areas .strip-red").css("top", positionAreas.top + "px");
                    $("#page-areas .strip-red").css("left", "0px");
                    $("#page-areas .strip-red").css("height", $("#current-area-gallery").height() + "px");
                }
                else {
                    var top = $("#areas").offset().top + $("#areas").height();
                    var height = heightDisplay - top - heightFooter;
                    $("#box-areas-mobile").css("top", top + "px");
                    $("#box-areas-mobile").height(height);
                }

                thisObj.$root.animejs({
                    targets: '#page-areas',
                    opacity: [0,1],
                    easing: "easeInOutQuad",
                    duration: 400
                });
            }, 500);
        },

        setEventCarousel() {
            $('#current-area-gallery .carousel').on('slide.bs.carousel', function() {
                //$(".alt-image").addClass("d-none");
                $(".alt-image").css("visibility", "hidden");
            });

            $('#current-area-gallery .carousel').on('slid.bs.carousel', function() {
                //$(".alt-image").removeClass("d-none");
                $(".alt-image").css("visibility", "visible");
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/areas.vue